import { useEffect, useState } from 'react';
import './style.css';

const Term = () => {

    const [content, setContent] = useState('');

    useEffect(() => {
        fetch('/TermsofUse.html')
            .then((res) => res.text())
            .then((data) => setContent(data));
    }, []);


    return (
        <div className="main-page-upcoming">
            <div className="container">
                <div className="wrap-upcoming">
                    <div className="group-action">
                        <div className="project-text">
                            <img src="./images/title-term.svg" alt="" />
                        </div>
                        <div className="box-dis" style={{ paddingTop: '0' }}>
                            <div
                                dangerouslySetInnerHTML={{ __html: content }}
                            />
                            {/* <img className="box-affter" src="/images/detail-ido/box-affter.png" alt="" /> */}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Term;
